// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import Layout from 'components/Layout';
import TitleHeader from 'components/TitleHeader';
import React from 'react';
import { Col, Container, Row, Tabs, Tab } from 'react-bootstrap';
import FaqBlock from './_FaqBlock';
import SEO from 'components/seo';

const Faq = () => {
  return (
    <Layout>
      <SEO
        title="Read our online letting agency FAQs - Oasis Living"
        description="Read through our FAQs for information about our online property letting and management services. Find out how we can improve your property letting experience"
      />
      <TitleHeader h1Title={true} title="FAQs" />

      <Container className="my-5">
        <Row>
          <Col>
            <p className="my-3">
              For your convenience the FAQs are divided into a few sections,
              please click on any of the tabs below
            </p>
            <Tabs defaultActiveKey="general">
              <Tab eventKey="general" title="General">
                <FaqBlock faqTableName="FAQ - General" />
              </Tab>
              <Tab eventKey="landlord" title="Landlord">
                <FaqBlock faqTableName="FAQ - Landlord" />
              </Tab>
              <Tab eventKey="tenant" title="Tenant">
                <FaqBlock faqTableName="FAQ - Tenant" />
              </Tab>
              <Tab eventKey="stays" title="Stays">
                <FaqBlock faqTableName="FAQ - Stays" />
              </Tab>
            </Tabs>

            {/* <FaqBlock faqTableName="tenantFaq"></FaqBlock>
          <FaqBlock faqTableName="staysFaq"></FaqBlock>
          <FaqBlock faqTableName="landlordFaq"></FaqBlock> */}

            {/* <FaqBlock name="Tenant-FAQ"/> */}
            {/* <h2>How do I contact Oasis Living?</h2>
            <p>
              You can contact Oasis Living at{' '}
              <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>{' '}
              with any queries you may have.
            </p>
            <h2>How can I cancel my booking?</h2>
            <p>
              Please refer to our{' '}
              <Link to="/terms-and-conditions/">cancellation policy</Link> if you
              wish to cancel your booking. Once you have read our cancellation
              policy, feel free to contact us at{' '}
              <a href="mailto:reservations@oasis-living.org">
                reservations@oasis-living.org
              </a>
            </p>
            <h2>What is your cancellation policy?</h2>
            <p>
              Our cancellation policy can be found{' '}
              <Link to="/terms-and-conditions/">here</Link>.
            </p>
            <h2>How can I shorten or extend my booking?</h2>
            <p>
              If you wish to shorten/extend your booking, please contact us at{' '}
              <a href="mailto:reservations@oasis-living.org">
                reservations@oasis-living.org
              </a>
            </p>
            <h2>Are the apartments pet-friendly?</h2>
            <p>
              Please refer to the website where all the relevant details will be
              provided on the listed apartment that you are looking to book.
            </p>
            <h2>Are the apartments non-smoking?</h2>
            <p>
              We have zero tolerance to smoking in each of our Oasis Living
              apartments.
            </p>
            <h2>Do the residences have washing and drying machines?</h2>
            <p>
              Please refer to the website where all the relevant details will be
              provided on the listed apartment that you are looking to book.
            </p>
            <h2>Do you have car parking spaces?</h2>
            <p>
              Please refer to the website where all the relevant details will be
              provided on the listed apartment that you are looking to book.
            </p>
            <h2>How do I request extra towels?</h2>
            <p>
              For all extra items, please reach out to us on
              <a href="mailto:info@oasis-living.org">info@oasis-living.org</a>
            </p> */}
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Faq;
